import {create} from "zustand";

const useContainerStore = create((set) => ({
    isContainerStatusUpdated: false,

    setContainerStatusUpdated: (status) => set({isContainerStatusUpdated: status}),
}));

export default useContainerStore